/**
 * Рейтинг игроков с сервера: топ-20 и ваша строка. Очки — всего заработано монет на рынке.
 */
import type { GameState } from '../../core/types';
import { fetchLeaderboard, submitScore, type LbRow } from '../../pay/lbclient';
import { getLang, t } from '../../i18n';
import { h, clearChildren } from '../dom';
import { openPanel } from '../modal';

const LOCALE: Record<string, string> = { ru: 'ru-RU', en: 'en-US', zh: 'zh-CN' };
const medal = (rank: number): string => ['🥇', '🥈', '🥉'][rank - 1] ?? String(rank);

export function openLeaderboard(state: GameState): void {
  openPanel({
    title: `🏆 ${t('panel.leaderboard')}`,
    className: 'panel-wide',
    body: (box) => {
      box.append(h('div', { class: 'lb-msg' }, t('lb.loading')));
      void (async () => {
        await submitScore(state, true);                     // свежие очки перед чтением рейтинга
        const view = await fetchLeaderboard(state);
        clearChildren(box);
        if (!view) { box.append(h('div', { class: 'lb-msg lb-warn' }, t('lb.offline'))); return; }

        const fmt = (n: number): string => n.toLocaleString(LOCALE[getLang()] ?? 'en-US');
        const row = (e: LbRow): HTMLElement => h('div', { class: `lb-row ${e.me ? 'me' : ''}` },
          h('span', { class: 'lb-pos' }, medal(e.rank)),
          h('span', { class: 'lb-name' }, e.me ? `${e.name} ${t('lb.you')}` : e.name),
          h('span', { class: 'lb-lv' }, `${t('ui.lvShort')} ${e.level}`),
          h('span', { class: 'lb-score' }, `🪙 ${fmt(e.score)}`),
        );
        const mine = view.top.find((e) => e.me) ?? view.me;
        box.append(h('div', { class: 'lb-head' },
          mine ? h('div', { class: 'lb-rank' }, t('lb.rank', { rank: mine.rank, total: view.total })) : null,
          h('div', { class: 'lb-hint' }, `${t('lb.score')} · ${t('lb.hint')}`),
        ));
        const rows = h('div', { class: 'lb-list' });
        for (const e of view.top) rows.append(row(e));
        if (view.me) { rows.append(h('div', { class: 'lb-gap' }, '⋮')); rows.append(row(view.me)); }
        box.append(rows);
        if (view.total <= 1) box.append(h('div', { class: 'lb-msg' }, t('lb.empty')));
        else box.append(h('div', { class: 'lb-hint', style: 'margin-top:8px' }, t('lb.total', { n: view.total })));
      })();
    },
  });
}
